var exports = {
  "Ij": "SearchEnginesTab.module__customEngineRow___eXUta0",
  "LW": "SearchEnginesTab.module__customEngineActions___eXUta0",
  "r9": "SearchEnginesTab.module__editButton___eXUta0",
  "DT": "SearchEnginesTab.module__removeButton___eXUta0",
  "QE": "SearchEnginesTab.module__newEngineButtonContainer___eXUta0",
  "gC": "SearchEnginesTab.module__noEnginesText___eXUta0",
};

module.exports = exports;
